import { render, staticRenderFns } from "./chat-request-user-list.html?vue&type=template&id=ef1fe374&scoped=true&external"
import script from "./chat-request-user-list.js?vue&type=script&lang=js&external"
export * from "./chat-request-user-list.js?vue&type=script&lang=js&external"
import style0 from "./chat-request-user-list.scss?vue&type=style&index=0&id=ef1fe374&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1fe374",
  null
  
)

export default component.exports